import { COMMON_AJAX_DELAY } from "./ApplicationConfig";
import ApplicationState from "./ApplicationState";
import DelayedCall from "./DelayedCall";
import { formDataToQueryString } from './form/QueryString';
import { prepareUrl } from "./Utils";
import { BREAKPOINTS } from './ApplicationConfig';

const xhr     = ApplicationState.axios;
const axios   = require('axios');

export default class QuickSearch {
    readonly hideClass = 'display_none';
    
    protected token: any;
    protected form: HTMLElement;
    protected popup: HTMLElement
    protected result: HTMLElement;
    protected showAll: HTMLLinkElement;
    protected closeButton: HTMLElement;
    protected action: string;
    protected delayedCall: DelayedCall;
    protected cancelToken: any = null;
    protected counter: HTMLElement;
    protected input: HTMLInputElement;

    public constructor(formSelector: string, action: string)
    {
        this.form = document.querySelector(formSelector) as HTMLFormElement;
        this.popup = this.form.querySelector('.js-quick-search-popup');
        this.result = this.form.querySelector('.js-quick-search-result');
        this.showAll = this.form.querySelector('.js-quick-search-show-all');
        this.closeButton = this.form.querySelector('.js-close-button');
        this.action = action;
        this.delayedCall = new DelayedCall();
        this.counter = this.form.querySelector('.js-quick-search-show-all-counter');
        this.input = this.form.querySelector('input[name="q"]') as HTMLInputElement;
    }

    public init ()
    {
        this.appendEventListeners();
    }

    protected appendEventListeners()
    {
        if (this.input === null) {
            return;
        }

        this.form.addEventListener('click', () => {
            this.form.classList.add('quick-search__expanded');
        }); 
        this.form.addEventListener('submit', e => {
            if (this.input.value == '') {
                e.preventDefault();
            }

            let params = new FormData;
            params.append('q', this.input.value);

            this.form.setAttribute('action', '/catalog/quick_search/?' + formDataToQueryString(params));
        });

        this.input.addEventListener('keyup', () => {
            if (this.cancelToken !== null) {
                this.cancelToken.cancel();
                this.cancelToken = null;
            }

            // если стерли поисковую фразу, удаляем крестик очистки поля
            if (this.input.value == '') {
                this.closeButton.classList.add(this.hideClass);
            }

            this.delayedCall.execute(this.search, COMMON_AJAX_DELAY, this, this.input.value);
        });

        this.closeButton.addEventListener('click', () => {
            this.showAll.classList.remove(this.hideClass);
            this.hideResult();
            this.input.value = '';
        });
    }

    protected hideResult()
    {
        this.popup.classList.add(this.hideClass);
        this.closeButton.classList.add(this.hideClass);
        this.input.classList.remove('quick-search__input_top-bordered');
    }

    protected showResult()
    {
        this.popup.classList.remove(this.hideClass);
        this.closeButton.classList.remove(this.hideClass);
        this.input.classList.add('quick-search__input_top-bordered');
    }

    protected showCount(count: number)
    {
        if (count > 0) {
            this.counter.innerText = `(${count})`;
            this.showAll.classList.remove(this.hideClass);
        }
    }

    protected search(phrase: string)
    {
        if (phrase.length < 3) {
            return;
        }

        this.cancelToken = axios.CancelToken.source();

        let params = new FormData();
        params.append('term', phrase);

        xhr.get(this.action + '?' + formDataToQueryString(params), {
            cancelToken: this.cancelToken.token,
        }).then(rsp => {
            if (rsp.data.status === 'OK') {
                this.renderList(rsp.data.list);
                this.showCount(rsp.data.count);
                this.showResult();
            } else {
                this.clearResult();
                this.renderMessage('');
                this.showResult();
            }
        })
        .catch(() => {
            this.clearResult();
            this.renderMessage('');
            this.showResult();
        }).then(() => {
            this.refreshShowAllLink(phrase);
            this.cancelToken = null;
        });
    }

    protected renderList(list: object[])
    {
        if (this.result === null) {
            return;
        }

        this.clearResult();

        if (list.length === 0) {
            this.renderMessage('Ничего не найдено');
            this.showAll.classList.add(this.hideClass);
        } else {
            list.forEach(item => this.renderItem(item));
        }
    }

    protected clearResult()
    {
        this.result.innerHTML = '';
    }

    protected renderMessage(text: string = '')
    {
        let itemNode = document.createElement('div');
        itemNode.classList.add('quick-search__empty');
        itemNode.innerText = text;

        this.result.appendChild(itemNode);
    }

    protected renderItem(item)
    {
        let itemNode = document.createElement('a');
        itemNode.classList.add('quick-search__item', 'link');
        itemNode.href = prepareUrl(item.url);

        let text = document.createElement('div');
        text.classList.add('quick-search__text');
        text.innerHTML = ` ${item.prefix}<br>` + `<span class="quick-search__text_bold"> ${item.title}</span>`;

        itemNode.appendChild(text);

        let separator = document.createElement('div');
        separator.classList.add('separator', 'separator_color_gray', 'quick-search__separator');

        this.result.appendChild(itemNode);
        this.result.appendChild(separator);
    }

    protected refreshShowAllLink(phrase: string)
    {
        this.showAll.href = '/catalog/quick_search?q=' + phrase;
    }
}
